$(document).ready(function(){
	var iw = 105;
	var ih = 108;
	var flies = [
		'Тихими взмахами крыльев бабочка улетает в ночь.',
		'Вы ловите бабочку, но вдруг она начинает светиться и, расходясь пучками света, растворяется в ваших руках.',
		'Легко взмахнув крыльями, бабочка растворилась в темноте.',
		'Вы дотронулись до бабочки, и приятное тепло разлилось по вашей руке от точки касания, но через мгновение оно исчезло. Как и бабочка.',
		'При приближении вашей руки бабочка засияла синим светом, которое обволокло ваше тело. Удача повысилась на 1.',
		'"Мне очень приятно", сказала бабочка, и пока вы приходили в себя от этой мысли, она растворилась в ночи.',
	];

	var rand = function(from, to){
		return Math.floor(Math.random() * (to - from) + from);
	};

	var mx = $(window).width() - iw;
	var my = $(window).height() - ih;

	var $el = $('<img src="/res/i/butterfly.gif"/>');
	$el.click(function(e){
		alert(flies[rand(0, flies.length)]);
		$(this).hide();
	});
	$el.css({
		position: 'fixed',
		display: 'none',
	});
	$el.appendTo('body');

	setInterval(function(){
		var h = new Date(Date.now()).getHours();
		if((h < 4 || h > 21) && Math.random() < 0.004){
			$el.css({
				left: rand(0, mx) + 'px',
				top: rand(0, my) + 'px',
			});
			$el.show();
		}
	}, 60000);
});
